import { render, staticRenderFns } from "./HivesChapter.vue?vue&type=template&id=578bee16&lang=pug&"
import script from "./HivesChapter.vue?vue&type=script&lang=ts&"
export * from "./HivesChapter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports